export function filenameContainsInvoiceNumber(filename: string, invoiceNumber: string): boolean {
  if (!filename || !invoiceNumber) return false;
  return filename.toLowerCase().includes(invoiceNumber.toLowerCase());
}
